import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=779a17a8&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"
import style0 from "./Tags.vue?vue&type=style&index=0&id=779a17a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a17a8",
  null
  
)

export default component.exports